<template>
  <div id="app">
    <navbar :isLoggedIn="isLoggedIn"></navbar>
    <div  class="container-fluid mt-4">
      <keep-alive v-if="isLoggedIn">
        <router-view/>
      </keep-alive>
      <router-view v-else></router-view>
    </div>
    <app-footer :isLoggedIn="isLoggedIn"></app-footer>
    <notifications position="bottom right" :max="3"/>

</div>
</template>
<script>
import AppFooter from "./components/common/AppFooter.vue"
import Navbar from "./components/common/Navbar.vue"
export default {
  name: "app",
  mounted: function() {
    this.$store.dispatch("loadSession")
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn
    }
  },
  components: {
    AppFooter,
    Navbar,
  }
}
</script>
<style>
.vue-notification-group {
  margin-bottom: 100px;
  margin-right: 25px;
}

#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #96cad4;
  padding-bottom: 50px;
}

.form-label {
  text-align: left;
}
#nav {
  padding: 40px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
